export const licenseId = "15030696";
